import React from "react";
import PropTypes from "prop-types";
import { ReactComponent as CheckIcon } from "assets/images/icons/Check.svg";
import { FormattedMessage } from "react-intl";
import { DateTimeFormat, formatDate } from "helpers/dateTimeHelper";
import Stop from "./Stop";

import "./Schedule.scss";

interface StopData {
  expected_stop_date: string;
  expected_stop_time: string;
  updated_stop_date: string;
  updated_stop_time: string;
  label: string;
  vessel_name?: string;
  vessel_number?: string;
  type?: string;
  flight_number?: string;
  port_name?: string;
  port_locode?: string;
}

interface ScheduleProps {
  schedule: StopData[];
  isDelivered: boolean;
  bookedDate?: string;
}

function Schedule({ schedule, isDelivered, bookedDate }: ScheduleProps): JSX.Element {
  return (
    <div className="tracking-schedule w-100 pr-4 align-self-start">
      <span className="progress-line" />
      <div>
        <div className="mt-3 d-flex align-items-center position-relative">
          <div
            style={{ backgroundColor: "white", width: 20, height: 26, position: "absolute", top: -3, left: -1, bottom: 0 }}
          />
          <CheckIcon height={18} width={18} style={{ transform: "translateY(1px)" }} />
          <div className="ml-3 d-flex w-100 justify-content-between font-b9">
            <p className="font-b4">
              <FormattedMessage id="tracking.components.statusCard.shipmentBooked" defaultMessage="Shipment booked" />
            </p>
            <p className="font-b4">{bookedDate ? formatDate(bookedDate, DateTimeFormat.shortDateTimeFormat) : "N/A"}</p>
          </div>
        </div>
        <hr className="separator" />
      </div>
      {schedule?.length > 0 &&
        schedule.map((stopData, index) => (
          <Stop key={index} stopData={stopData} isLastStop={schedule.length - 1 === index} isDelivered={isDelivered} />
        ))}
    </div>
  );
}

Schedule.propTypes = {
  schedule: PropTypes.instanceOf(Array).isRequired,
  isDelivered: PropTypes.bool.isRequired,
  bookedDate: PropTypes.string,
};

Schedule.defaultProps = {
  bookedDate: null,
};

export default Schedule;
